import * as React from 'react';
const SvgScorecard = (props) => (
  <svg
    viewBox="0 0 153 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M75.7991 115.721C107.569 115.721 133.34 89.8209 133.34 57.7967C133.34 25.7725 107.569 0 75.7991 0C44.03 0 18.2576 25.9001 18.2576 57.9243C18.2576 89.9485 44.03 115.721 75.7991 115.721Z"
      fill="#EAEEF9"
    />
    <path
      d="M104.124 114.955C95.3194 115.21 84.8577 114.955 77.33 114.828C69.9301 115.083 59.3404 115.21 50.5369 114.955C59.2128 109.979 62.2748 100.793 62.6576 94.6692H91.7474C92.5129 100.665 95.575 109.979 104.124 114.955Z"
      fill="url(#paint0_linear_1055_3955)"
    />
    <g filter="url(#filter0_d_1055_3955)">
      <path
        d="M132.32 17.4791V93.6479C132.32 95.5621 130.789 96.966 129.13 96.966H26.1679C24.3817 96.966 22.9783 95.4343 22.9783 93.6479V17.4791C22.9783 15.6929 24.5093 14.1619 26.1679 14.1619H129.003C130.917 14.1619 132.32 15.6929 132.32 17.4791Z"
        fill="white"
      />
    </g>
    <path
      d="M132.32 17.4791V83.0586H22.9783V17.4791C22.9783 15.6929 24.5093 14.1619 26.1679 14.1619H129.003C130.917 14.1619 132.32 15.6929 132.32 17.4791Z"
      fill="#989FB0"
    />
    <path
      d="M128.11 18.3723H26.6782V79.3587H128.237V18.3723H128.11Z"
      fill="white"
    />
    <path
      d="M77.4576 92.4215C78.9887 92.4215 80.1369 91.2731 80.1369 89.7421C80.1369 88.2111 78.9887 87.0627 77.4576 87.0627C75.9266 87.0627 74.7783 88.2111 74.7783 89.7421C74.7783 91.2731 75.9266 92.4215 77.4576 92.4215Z"
      fill="#D0D8E6"
    />
    <path
      d="M122.24 29.6001V37.3828C122.24 38.5311 121.348 39.4242 120.199 39.4242H34.461C33.3128 39.4242 32.4197 38.5311 32.4197 37.3828V29.6001C32.4197 28.4518 33.3128 27.5587 34.461 27.5587H120.072C121.348 27.4311 122.24 28.4518 122.24 29.6001Z"
      fill="#E5E9F1"
    />
    <path
      d="M44.4127 27.4309V39.5516H34.3333C33.1851 39.5516 32.292 38.6585 32.292 37.5103V29.7275C32.292 28.5791 33.1851 27.686 34.3333 27.686L44.4127 27.4309Z"
      fill="#E3EAF2"
    />
    <path
      opacity={0.8}
      d="M122.24 45.9309V53.7137C122.24 54.8619 121.348 55.755 120.199 55.755H34.461C33.3128 55.755 32.4197 54.8619 32.4197 53.7137V45.9309C32.4197 44.7826 33.3128 43.8895 34.461 43.8895H120.072C121.348 43.7619 122.24 44.7826 122.24 45.9309Z"
      fill="#E5E9F1"
    />
    <path
      d="M44.4127 27.4309V39.5516H34.3333C33.1851 39.5516 32.292 38.6585 32.292 37.5103V29.7275C32.292 28.5791 33.1851 27.686 34.3333 27.686L44.4127 27.4309Z"
      fill="#989FB0"
    />
    <path
      d="M38.0333 36.1066C37.7782 36.1066 37.523 35.9791 37.3955 35.8514L35.4816 33.9376C35.0989 33.5549 35.0989 33.0445 35.4816 32.6618C35.8644 32.279 36.3747 32.279 36.7575 32.6618L37.9057 33.81L40.7126 31.0032C41.0954 30.6204 41.6057 30.6204 41.9885 31.0032C42.3713 31.3859 42.3713 31.8963 41.9885 32.279L38.5437 35.7238C38.4161 35.9791 38.1609 36.1066 38.0333 36.1066Z"
      fill="white"
    />
    <path
      opacity={0.5}
      d="M122.24 62.262V70.0448C122.24 71.1931 121.348 72.0862 120.199 72.0862H34.461C33.3128 72.0862 32.4197 71.1931 32.4197 70.0448V62.262C32.4197 61.1137 33.3128 60.2206 34.461 60.2206H120.072C121.348 60.0931 122.24 60.9862 122.24 62.262Z"
      fill="#E5E9F1"
    />
    <path
      opacity={0.3}
      d="M122.24 78.4657V79.3588H32.292V78.4657C32.292 77.3174 33.1851 76.4243 34.3333 76.4243H120.071C121.347 76.4243 122.24 77.3174 122.24 78.4657Z"
      fill="#E5E9F1"
    />
    <path
      d="M30.8885 23.0929C31.5264 23.0929 32.0368 22.5826 32.0368 21.9447C32.0368 21.3067 31.5264 20.7964 30.8885 20.7964C30.2506 20.7964 29.7402 21.3067 29.7402 21.9447C29.7402 22.5826 30.2506 23.0929 30.8885 23.0929Z"
      fill="#E3EAF2"
    />
    <path
      d="M34.5888 23.0929C35.2266 23.0929 35.737 22.5826 35.737 21.9447C35.737 21.3067 35.2266 20.7964 34.5888 20.7964C33.9508 20.7964 33.4404 21.3067 33.4404 21.9447C33.4404 22.5826 33.9508 23.0929 34.5888 23.0929Z"
      fill="#E3EAF2"
    />
    <path
      d="M38.2885 23.0929C38.9263 23.0929 39.4367 22.5826 39.4367 21.9447C39.4367 21.3067 38.9263 20.7964 38.2885 20.7964C37.6505 20.7964 37.1401 21.3067 37.1401 21.9447C37.1401 22.5826 37.6505 23.0929 38.2885 23.0929Z"
      fill="#E3EAF2"
    />
    <path
      d="M1.81299 115.095H149.187"
      stroke="#989FB0"
      strokeWidth={1.86568}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.364 50.0255C13.4763 50.0255 15.1886 48.3132 15.1886 46.2009C15.1886 44.0886 13.4763 42.3762 11.364 42.3762C9.25167 42.3762 7.53931 44.0886 7.53931 46.2009C7.53931 48.3132 9.25167 50.0255 11.364 50.0255Z"
      fill="#EAEEF9"
    />
    <path
      d="M7.53945 37.6187C8.98199 37.6187 10.1514 36.4493 10.1514 35.0067C10.1514 33.5642 8.98199 32.3948 7.53945 32.3948C6.0969 32.3948 4.92749 33.5642 4.92749 35.0067C4.92749 36.4493 6.0969 37.6187 7.53945 37.6187Z"
      fill="#EAEEF9"
    />
    <path
      d="M116.705 7.0098C118.147 7.0098 119.317 5.84039 119.317 4.39784C119.317 2.9553 118.147 1.78589 116.705 1.78589C115.262 1.78589 114.093 2.9553 114.093 4.39784C114.093 5.84039 115.262 7.0098 116.705 7.0098Z"
      fill="#EAEEF9"
    />
    <path
      d="M144.336 59.6466C147.015 59.6466 149.187 57.4749 149.187 54.7958C149.187 52.1168 147.015 49.9451 144.336 49.9451C141.657 49.9451 139.486 52.1168 139.486 54.7958C139.486 57.4749 141.657 59.6466 144.336 59.6466Z"
      fill="#EAEEF9"
    />
    <defs>
      <filter
        id="filter0_d_1055_3955"
        x={2.45576}
        y={3.90061}
        width={150.386}
        height={123.849}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={10.2613} />
        <feGaussianBlur stdDeviation={10.2613} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1055_3955"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1055_3955"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1055_3955"
        x1={77.3405}
        y1={114.389}
        x2={77.3405}
        y2={96.2205}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E8ECF5" />
        <stop offset={0.9913} stopColor="#BDC4D7" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgScorecard;
